
export enum CastApiErrorCode {
  CREATE_CAST = 'create_cast',
  UPDATE_CAST = 'update_cast',
  UPDATE_EVENT = 'update_event',
  DEFAULT_LAYOUT_UNDEFINED = 'default_layout_undefined',
  NO_CURRENT_USER_ID = 'no_current_user_id',
  NO_TEAM_ID = 'no_team_id',
  GET_COPY = 'get_copy',
  CREATE_SCENE = 'create_scene'
}
